import { render, staticRenderFns } from "./ConfiguracaoIncisos.vue?vue&type=template&id=0044a98d&scoped=true"
import script from "./ConfiguracaoIncisos.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoIncisos.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracaoIncisos.vue?vue&type=style&index=0&id=0044a98d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0044a98d",
  null
  
)

export default component.exports